export default {
  tokenCommit (state, data) {
    state.token = data
  }
}
